// components/Footer.js
import React from 'react';
import './Footer.css';
// import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo">
                <img src='/logo.svg' alt="Company Logo" className="logo-image" />
            </div>
            <p className="footer-tagline">
              Advancing the frontier of machine learning
            </p>
          </div>

          <div className="footer-links">
            {/* <div className="footer-section">
              <h3 className="footer-heading">Product</h3>
              <ul className="footer-list">
                <li><Link to="/datasets">Datasets</Link></li>
              </ul>
            </div>

            <div className="footer-section">
              <h3 className="footer-heading">Company</h3>
              <ul className="footer-list">
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div> */}

            <div className="footer-section">
              <h3 className="footer-heading">Connect</h3>
              <div className="social-links">
                <a href="https://github.com/primordic" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="GitHub">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M12 2C6.477 2 2 6.477 2 12c0 4.42 2.865 8.17 6.839 9.49.5.092.682-.217.682-.482 0-.237-.008-.866-.013-1.7-2.782.603-3.369-1.34-3.369-1.34-.454-1.156-1.11-1.464-1.11-1.464-.908-.62.069-.608.069-.608 1.003.07 1.531 1.03 1.531 1.03.892 1.529 2.341 1.087 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.11-4.555-4.943 0-1.091.39-1.984 1.029-2.683-.103-.253-.446-1.27.098-2.647 0 0 .84-.269 2.75 1.025A9.578 9.578 0 0112 6.836c.85.004 1.705.114 2.504.336 1.909-1.294 2.747-1.025 2.747-1.025.546 1.377.203 2.394.1 2.647.64.699 1.028 1.592 1.028 2.683 0 3.842-2.339 4.687-4.566 4.935.359.309.678.919.678 1.852 0 1.336-.012 2.415-.012 2.743 0 .267.18.578.688.48C19.138 20.167 22 16.418 22 12c0-5.523-4.477-10-10-10z" fill="currentColor"/>
                  </svg>
                </a>
                <a href="https://huggingface.co/primordic" target="_blank" rel="noopener noreferrer" className="social-link hf-container" aria-label="Hugging Face">
                    <img src='/huggingface.svg' alt="Huggingface Logo" className="hf-logo" />
                </a>
                {/* <a href="https://twitter.com/yourcompany" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Twitter">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" fill="currentColor"/>
                  </svg>
                </a>
                <a href="https://linkedin.com/company/yourcompany" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="LinkedIn">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" fill="currentColor"/>
                  </svg>
                </a> */}
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-legal">
            <p className="copyright">© {currentYear} Primordic. All rights reserved.</p>
            {/* <div className="legal-links">
              <a href="#privacy">Privacy Policy</a>
              <span className="separator">•</span>
              <a href="#terms">Terms of Service</a>
              <span className="separator">•</span>
              <a href="#cookies">Cookie Policy</a>
            </div> */}
          </div>
          {/* <div className="footer-badge">
            <span>Built with precision</span>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M8 1.5L10.5 6.5L16 7.5L12 11.5L13 16.5L8 14L3 16.5L4 11.5L0 7.5L5.5 6.5L8 1.5Z" fill="currentColor"/>
            </svg>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
